import { forwardRef, type SVGProps } from 'react';

export type ExclamationCircleOutlinedIconProps = Omit<SVGProps<SVGSVGElement>, 'css'>;

export const ExclamationCircleOutlinedIcon = forwardRef<SVGSVGElement, ExclamationCircleOutlinedIconProps>(
  (props, ref) => (
    <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
      <path
        d="M8.029 10.442C8.462 10.443 8.808 10.789 8.808 11.221 8.808 11.654 8.462 12 8.029 12 7.596 12 7.25 11.654 7.25 11.221 7.25 10.789 7.596 10.442 8.029 10.442ZM8.029 4.5C8.433 4.5 8.75 4.846 8.721 5.279L8.491 9.231C8.462 9.49 8.289 9.692 8.029 9.692 7.77 9.692 7.596 9.519 7.567 9.231L7.336 5.279C7.336 4.846 7.654 4.5 8.029 4.5Z"
        fill="currentColor"
      />
      <path
        clipRule="evenodd"
        d="M8.00032 1C9.85593 1.00268 11.635 1.7411 12.9471 3.05322C14.2592 4.3654 14.9977 6.14435 15.0003 8C15.0003 9.38444 14.5898 10.738 13.8206 11.8892C13.0515 13.0402 11.958 13.9375 10.679 14.4673C9.40002 14.9971 7.99239 15.1358 6.6346 14.8657C5.27679 14.5956 4.02956 13.9286 3.05061 12.9497C2.07167 11.9708 1.4047 10.7236 1.1346 9.36572C0.864504 8.00788 1.00324 6.60035 1.53303 5.32129C2.06284 4.04224 2.96005 2.94884 4.11116 2.17969C5.26228 1.41057 6.6159 1 8.00032 1ZM8.00032 2.18311C6.45845 2.18571 4.98027 2.79942 3.88997 3.88965C2.79965 4.97996 2.18603 6.45806 2.18342 8C2.18342 9.15047 2.52424 10.2754 3.1634 11.2319C3.80257 12.1885 4.71139 12.9338 5.77424 13.374C6.8371 13.8142 8.00677 13.9295 9.13508 13.7051C10.2634 13.4806 11.3001 12.9267 12.1136 12.1133C12.927 11.2998 13.481 10.2631 13.7054 9.13477C13.9298 8.00645 13.8146 6.83678 13.3743 5.77393C12.9341 4.71108 12.1883 3.80273 11.2318 3.16357C10.2753 2.52447 9.15068 2.18316 8.00032 2.18311Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
);

ExclamationCircleOutlinedIcon.displayName = 'ExclamationCircleOutlinedIcon';
